"use client";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";

interface CareersHeroTitleProps {
  line1: string;
  line2: string;
}

/**
 * Careers hero title — responsive line break without touching ScrollRevealText.
 *
 * Both layouts stay in the DOM; Tailwind visibility toggles by breakpoint so
 * SSR and client paint the same markup (no one-line vs two-line hydration
 * mismatch from viewport-dependent <br> tags inside ScrollRevealText).
 */
export function CareersHeroTitle({ line1, line2 }: CareersHeroTitleProps) {
  const fullTitle = `${line1} ${line2}`;

  return (
    <>
      <span className="hidden lg:contents">
        <ScrollRevealText variant="dark">{fullTitle}</ScrollRevealText>
      </span>
      <span className="flex flex-col lg:hidden">
        <ScrollRevealText variant="dark">{line1}</ScrollRevealText>
        <ScrollRevealText variant="dark">{line2}</ScrollRevealText>
      </span>
    </>
  );
}
